import React, { FC, useEffect, useMemo } from 'react';
import { useParams } from 'react-router';

import { EvMainTitle } from '@evinced-private/ui-common';

import { ComponentDrillDownViewWithObserver } from '../../pages/scan-analysis/views/component-drilldown/ComponentDrilldownViewV2';
import { useNavigation } from '../../providers/navigationProvider/NavigationProvider';
import { IPropertyViewContext, usePropertyViewContext } from '../../providers/PropertyViewProvider';
import { EvPropertyViews } from '../common/ev-property-views/EvPropertyViews';
import { PropertyViewLoadErrorPage } from '../common/ev-property-views/PropertyViewLoadErrorPage';

import './DrilldownPage.scss';

export const ComponentDrilldownPage: FC = () => {
	const { propertyId, scanId, componentId } = useParams<{ [key: string]: string }>();
	const { setCurrentRoute } = useNavigation();

	const propertyViewContext: IPropertyViewContext = usePropertyViewContext();
	const viewId: string = useMemo(() => propertyViewContext?.currentView?.id, [propertyViewContext]);
	const viewLoadErr: boolean = useMemo(
		() => propertyViewContext?.loadViewErr,
		[propertyViewContext]
	);
	const title = `${componentId} Component details`;

	const currentRoute = useMemo(() => {
		if (!propertyId || !componentId) {
			return null;
		}

		return {
			id: propertyId,
			title
		};
	}, [propertyId, title, componentId]);

	useEffect(() => {
		if (currentRoute) {
			setCurrentRoute(currentRoute);
		}
		return () => {
			setCurrentRoute(null);
		};
	}, [currentRoute, setCurrentRoute]);

	if (viewLoadErr) {
		return <PropertyViewLoadErrorPage propertyId={propertyId} />;
	}

	return (
		<div className="drilldown-page">
			<div className="drilldown-page-content">
				<div className="header">
					<EvMainTitle className="page-heading">{title}</EvMainTitle>
					<div className="filtered-views-controller">
						<EvPropertyViews propertyId={propertyId} />
					</div>
				</div>
				<ComponentDrillDownViewWithObserver
					viewId={viewId}
					scanId={scanId}
					componentId={componentId}
					propertyId={propertyId}
				/>
			</div>
		</div>
	);
};
